// extracted by mini-css-extract-plugin
export var aboveInput = "_li-0";
export var actionButton = "_li-5";
export var actionButtonContainer = "_li-1";
export var actionIcon = "_li-6";
export var aiInfoContainer = "_li-2";
export var attachmentWrapper = "_li-7";
export var bold = "_li-3";
export var checkIcon = "_li-8";
export var clickingRecipientBar = "_li-11";
export var commentThreadSwitch = "_li-a";
export var draftImage = "_li-b";
export var draftImageContainer = "_li-c";
export var draftImages = "_li-e";
export var editButton = "_li-g";
export var editor = "_li-f";
export var editorContainer = "_li-y";
export var editorErrorTooltipWrapper = "_li-9";
export var headerDivider = "_li-h";
export var icon = "_li-i";
export var info = "_li-j";
export var internal = "_li-n";
export var internalDivider = "_li-k";
export var internalMessage = "_li-l";
export var messageInputCard = "_li-m";
export var messageInputForm = "_li-o";
export var messageInputFormInternal = "_li-p";
export var options = "_li-q";
export var publicMessageCustomer = "_li-s";
export var publicMessageMerchant = "_li-r";
export var removeImageButton = "_li-d";
export var replyButtons = "_li-t";
export var showSignatureButton = "_li-u";
export var spinner = "_li-v";
export var verticalButtonDivider = "_li-4";
export var visibilitySelector = "_li-w";
export var warning = "_li-x";
export var wrappingText = "_li-z";
export var writingInternalNoteTopBorder = "_li-10";